export default "__VITE_ASSET__DYlPCdMz__"